import Panel from './panel.vue';

export default Panel;